import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  convertTo12HourFormat,
  formatDateTimezon,
} from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../components-bootstrap/PayoutsTable";
import TransferHistory from "./TransferHistory";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const TransferListings = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  const { transferedPT, transferedPTLoading, transferedPTError } = useSelector(
    (state) => state.features
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    partialDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  useEffect(() => {
    if (
      transferedPT?.status &&
      transferedPT?.data?.length > 0 &&
      !transferedPTLoading &&
      !transferedPTError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: transferedPT.data,
        pagination:
          transferedPT?.pagination?.length > 0 ? transferedPT.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [transferedPT, transferedPTLoading, transferedPTError]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.member_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "trainer_id",
      text: "trainer detail",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "PT_transfer_history",
                rowData: row,
              }));
            }}
          >
            {row?.trainer_name || "NA"} <br />
            <small className="lowercase underline">
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "transferred_from",
      text: "transferred from",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.transferred_from_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.transferred_from_mobile || ""}
              <br />
              {row?.transferred_from_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "is_transferred",
      text: "transfered",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_transferred ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "is_transferred",
      text: "slot time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <small>
              {row?.start_time ? convertTo12HourFormat(row.start_time) : "-"} -{" "}
              {row?.end_time ? convertTo12HourFormat(row.end_time) : "-"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "session_status",
      text: "session status(No of Days)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.subscription_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "10px 15px",
          }}
        >
          {row?.subscription_status || "NA"}
        </span>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial ? "link" : ""}`}
          onClick={() =>
            row?.is_partial
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row?.is_partial
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online/Cash Amount",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">
          <small>
            ₹
            {convertThenFormat(
              row?.is_partial
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
            / ₹
            {convertThenFormat(
              row?.is_partial ? row?.partial_total_cash : row?.total_cash || 0
            )}
          </small>
        </span>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "partial_details" ? "mod-width-50p" : ""
          }`}
        >
          <ModalHeadAndClose
            title={modValues.modName?.replace(/_/g, " ")}
            onClose={onCloseModal}
          />

          {modValues.modName === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : modValues.modName === "PT_transfer_history" ? (
            <TransferHistory
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {transferedPTLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default TransferListings;
